import { Epic } from "redux-observable";
import { filter, switchMap, map, catchError, tap } from "rxjs/operators";
import { of } from "rxjs";
import { RootState } from "@/store/types";
import WorkflowAnalyticService from "@/features/workflow/services/WorkflowAnalyticService";



import { workflowAnalyticActions } from "./workflowAnalyticSlice";

/**
 * Epic để trigger analytics pipeline workflow
 */
export const triggerAnalyticsPipeEpic: Epic<any, any, RootState> = (
  action$
) =>
  action$.pipe(
    filter(
      (action) =>
        action.type === workflowAnalyticActions.triggerAnalyticsPipeRequest.type
    ),
    switchMap((action) => {
      return WorkflowAnalyticService.Post.triggerAnalyticsPipe(action.payload).pipe(
        tap((response) => {
          console.log("Workflow success:", response);
        }),
        map((response) =>
          workflowAnalyticActions.triggerAnalyticsPipeSuccess(response)
        ),
        catchError((error) => {
          console.error("Workflow error:", error);
          return of(
            workflowAnalyticActions.triggerAnalyticsPipeFailure(error)
          );
        })
      );
    })
  );

export const workflowAnalyticEpics = [triggerAnalyticsPipeEpic];
